<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("unpaid") }} {{ $t("booking") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
              <b-dropdown :disabled="disabledCinema" :text="selectedCinema" name="selectcinema" id="selectcinema"
                variant="dropdown-curve" class="w-100">
                <div class="px-2 pb-2">
                  <input required autofocus type="search" :placeholder="$t('searchCinema')"
                    class="form-control form-control-sm" v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)" v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema" />
                </div>
                <b-dropdown-item href="#" v-for="(Cinema, CinemaIndex) in Cinemas" :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)">{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <!-- Show Date From-->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button v-if="fetchTransactionDetail.show_date" v-on:click="fetchTransactionDetail.show_date = ''"
                  class="btn-clearDate">
                  ✖
                </button>
                <Datepicker :monday-first="true" ref="programaticOpen" v-model="fetchTransactionDetail.show_date"
                  name="selectenddate_2" id="selectenddate_2" v-validate="'required'" :typeable="true"
                  :disabled="disabledShoWDate" @input="onChangeShowDate()"></Datepicker>
                <label :class="fetchTransactionDetail.show_date ? 'active' : ''">{{ $t("show") }} {{ $t("date")
                  }}</label>
              </div>
            </div>
          </div>
          <div v-if="
            selectedFilter &&
            selectedFilter.length > 0 &&
            selectedFilter != 'Show Booking Code' &&
            selectedFilter != 'User'
          " class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container menu-item-truncate mr-2">
              <label :class="selectedFilterValue && selectedFilterValue.length > 0
                  ? 'shift-up'
                  : ''
                ">{{ selectedFilter }}</label>
              <b-dropdown :text="selectedFilterValue" name="selectuser" id="selectcinema" variant="dropdown-curve"
                class="w-100" :disabled="true">
                <div class="px-2 pb-2">
                  <input required autofocus type="search" placeholder="Search Filters"
                    class="form-control form-control-sm" v-on:keyup="onSearchFilterValues()"
                    v-on:keydown="onSearchFilterValues()" v-model="searchFilterValues" />
                </div>
                <b-dropdown-item href="#" v-for="(value, valueIndex) in filterValues" :key="valueIndex"
                  v-on:click="onSelectFilterValue(value)">{{
                    value.username
                      ? value.username
                      : value.movie
                        ? value.movie
                        : value.screen_name
                  }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div v-if="selectedFilter == 'Show Booking Code'" class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input placeholder="." type="text" v-model="filtervalue" name="firstname" id="firstname" />
                <label>{{ $tc("showBookingCode") }}</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <b-form-input v-model="searchValue" v-debounce:800="onSearchReservation"
              placeholder="Search "></b-form-input>
          </div>
          <div v-if="selectedFilter == 'User'" class="col-lg-4 col-xl-3 align-self-center mb-4">
            <multiselect v-model="searchUserValue" label="username" track-by="user_id"
              :placeholder="$tc('typeToSearchUser')" open-direction="bottom" :options="searchUsers" :multiple="false"
              :options-limit="50" :max-height="600" :loading="isSearchLoading" @select="onSelectFilterValue($event)"
              @search-change="onAsyncSearchUser">
              <span slot="noResult">Oops! No Results found.</span>
            </multiselect>
          </div>

          <div v-if="fetchTransactionDetail.show_date && ScheduleUnpaidDetais"
            class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2 menu-item-truncate">
              <label :class="selected_show_time ? 'shift-up' : ''">{{
                $t("Showtime")
              }}</label>
              <b-dropdown :text="getShowtimeString(selected_show_time)" name="selectuser" id="selectcinema"
                variant="dropdown-curve" class="w-100" :disabled="true">
                <b-dropdown-item href="#" v-for="(value, valueIndex) in schedules" :key="valueIndex"
                  v-on:click="onSelectShowtime(value)">{{
                    moment(value.ss_actual_start_date_time).format("DD-MM-YYYY")
                  }}
                  {{ value.ss_start_show_time }} ({{
                    value.movie
                  }})</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-4">
            <button :disabled="btenable" @click.prevent.stop="onFetchUnpaidBookings" class="btn-blue-lg w-80"
              style="height: 35px">
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-0">
            <b-dropdown name="listview" id="listview" variant="outline-blue" class="mb-4">
              <template v-slot:button-content>
                {{ $tc("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;Of&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item v-for="(list, listIndex) in viewingnumbers" :key="listIndex"
                @click="onDropDownChangeValue(list.name)">{{ list.name }}</b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="d-flex align-items-center" style="float: right">
              Download as:
              <a href="#" @click="ExportExcel()" title="Download as Excel">
                <img class="mx-1" src="@/assets/img/icons/excel.svg" height="25" width="25" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end align-items-center"></div>

        <!--Excel Export Start-->
        <div class="swc-report d-none" ref="exportable_table">
          <tr>
            <td>Cinema Name</td>
            <td>{{ this.selectedCinema }}</td>
          </tr>
          <tr>
            <td>Show Date:</td>

            <td>
              {{ moment(this.show_date).format("L") }}
            </td>
          </tr>
          <tr rowspan="1"></tr>

          <table class="swc-report-table mb-3" border="1">
            <thead>
              <tr>
                <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("phone") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
                <th>
                  {{ $tc("booking") }} {{ $tc("date") }} & {{ $tc("time") }}
                </th>
                <th>{{ $tc("reservation", 1) }} {{ $t("id") }}</th>
                <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
                <th>{{ $tc("film") }} {{ $tc("name") }}</th>
                <th>{{ $tc("show") }} {{ $tc("date") }} & {{ $tc("time") }}</th>
                <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
                <th>Reserved By</th>
                <th>Remarks</th>
                <!-- <th>{{ $t("action") }}</th> -->
                <!-- <th>{{ $t("Send Mail") }}</th> -->
              </tr>
            </thead>
            <tbody v-for="(item, itemIndex) in getReservationList" :key="itemIndex" class="sph-report">
              <tr>
                <td>
                  {{
                    item.customer_full_name | filterNullUndefined | capitalize
                  }}
                </td>
                <td>{{ item.cust_mobile | filterNullUndefined }}</td>
                <td>{{ item.cust_email | filterNullUndefined }}</td>
                <td>{{ item.booking_date_time }}</td>
                <td>{{ item.reservation_id }}</td>
                <td>{{ item.screen_name }}</td>
                <td>{{ item.movie_title }}</td>
                <td>
                  {{ item.ss_actual_start_date | dateparse }}
                  {{ item.ss_start_show_time }}
                </td>
                <td>{{ item.sl_seat_name }}</td>
                <td>{{ item.user_name }}</td>
                <td>{{ item.sstr_remarks }}</td>
                <!-- <td>
                  <b-button
                    variant="default"
                    @click="openCancelPopUp(item.reservation_id)"
                    class="btn-blue v-step-1"
                    >{{ $tc("Cancel") }}</b-button
                  >
                </td> -->

                <!-- <td>
                  <b-button
                    variant="default"
                    @click="sendMailConfirm(item.reservation_id,item.customer_id)"
                    class="btn-blue v-step-1"
                    v-if="item.customer_id">{{ $tc("Send Mail") }}</b-button
                  >
                  <span v-else>-</span>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <!--Excel Export End-->
        <div class="swc-report">
          <table class="swc-report-table mb-3" border="1">
            <thead>
              <tr>
                <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("phone") }}</th>
                <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
                <th>
                  {{ $tc("booking") }} {{ $tc("date") }} & {{ $tc("time") }}
                </th>
                <th>{{ $tc("reservation", 1) }} {{ $t("id") }}</th>
                <th>{{ $tc("screen", 1) }} {{ $tc("name", 1) }}</th>
                <th>{{ $tc("film") }} {{ $tc("name") }}</th>
                <th>{{ $tc("show") }} {{ $tc("date") }} & {{ $tc("time") }}</th>
                <th>{{ $tc("seat", 1) }} {{ $tc("number", 1) }}</th>
                <th>Reserved By</th>
                <th>Remarks</th>
                <th>{{ $t("action") }}</th>
                <!-- <th>{{ $t("Send Mail") }}</th> -->
              </tr>
            </thead>
            <tbody v-for="(item, itemIndex) in getReservationList" :key="itemIndex" class="sph-report">
              <tr>
                <td>
                  {{
                    item.customer_full_name | filterNullUndefined | capitalize
                  }}
                </td>
                <td>{{ item.cust_mobile | filterNullUndefined }}</td>
                <td>{{ item.cust_email | filterNullUndefined }}</td>
                <td>{{ item.booking_date_time }}</td>
                <td>{{ item.reservation_id }}</td>
                <td>{{ item.screen_name }}</td>
                <td>{{ item.movie_title }}</td>
                <td>
                  {{ item.ss_actual_start_date | dateparse }}
                  {{ item.ss_start_show_time }}
                </td>
                <td>{{ item.sl_seat_name }}</td>
                <td>{{ item.user_name }}</td>
                <td>{{ item.sstr_remarks }}</td>
                <td>
                  <b-button variant="default" @click="openCancelPopUp(item.reservation_id)" class="btn-blue v-step-1">{{
                    $tc("Cancel") }}</b-button>
                </td>
                <!-- <td>
                  <b-button
                    variant="default"
                    @click="sendMailConfirm(item.reservation_id,item.customer_id)"
                    class="btn-blue v-step-1"
                    v-if="item.customer_id">{{ $tc("Send Mail") }}</b-button
                  >
                  <span v-else>-</span>
                </td> -->
              </tr>
            </tbody>
            <tbody v-if="getReservationList.length == 0">
              <tr>
                <td colspan="13">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <b-modal id="sendMailConfirmation" title="Send Mail" hide-footer no-close-on-backdrop>
        <div class="text-center pb-1">
          <p class="fs-16 mb-2">
            {{
              `Are you sure you want to send mail for ${selected_reservation_id}`
            }}
          </p>

          <button class="btn-outline-blue" @click.prevent.stop="$bvModal.hide('sendMailConfirmation')">
            Cancel
          </button>
          <span class="mx-1"></span>
          <button class="btn btn-blue btn-blue-lg px-4 fs-14" @click.prevent.stop="sendMail">
            Confirm
          </button>
        </div>
      </b-modal>
      <b-pagination v-if="getReservationList.length > 0" v-model="currentPage" :total-rows="rows"
        @change="onChangePagination($event)" :per-page="perPage" aria-controls="my-table" class="my-3"></b-pagination>
    </div>
    <b-modal id="confirmation" title="Delete Unpaid Booking?" hide-footer no-close-on-backdrop>
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{
            `Are you sure you want to release Unpaid Booking For Reservation ID ${selected_reservation_id}`
          }}
        </p>

        <button class="btn-outline-blue" @click.prevent.stop="$bvModal.hide('confirmation')">
          Cancel
        </button>
        <span class="mx-1"></span>
        <button class="btn btn-danger btn-danger-lg px-4 fs-14" @click.prevent.stop="cancelUnpaidBooking">
          Confirm
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import ExhibitorService from "@/services/ExhibitorService";
import UserService from "@/services/UserService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import scheduleService from "@/services/scheduleService";
import PosService from "@/services/PosService";
import Printd from "printd";
import * as XLSX from "xlsx";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, Multiselect, NoRecords },
  data() {
    return {
      disabledCinema: false,
      disabledShoWDate: false,
      selected_reservation_id: null,
      getReservationList: [],
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isRoleID: true,
      transactionList: [],
      transactionListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,
      schedules: [],
      selected_ssid: "",
      selected_show_time: null,
      ScheduleUnpaidDetais: false,
      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      fetchTransactionDetail: {
        date: "",
        cinema_id: null,
        ss_id: "",
        show_date: new Date(),
        show_date_to: null,
        transaction_date: "",
        transaction_date_to: null,
      },
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      selected_reservation_id: "",
      selected_customer_id: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    // let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    // if (CinemaObj) {
    //   this.onSelectCinema(null, CinemaObj);
    // }

    let queryparams = this.$route.query;
    console.log("queryparams", queryparams);

    if (queryparams.cinema_id && parseInt(queryparams.cinema_id)) {
      this.fetchTransactionDetail.cinema_id = parseInt(queryparams.cinema_id);
      this.disabledCinema = true;
      let CinemaObjNew = this.Cinemas.find(
        (x) => x.cine_id == parseInt(queryparams.cinema_id)
      );
      if (CinemaObjNew) {
        this.onSelectCinema(null, CinemaObjNew);
      }
    }

    if (queryparams.date) {
      this.fetchTransactionDetail.show_date = queryparams.date;
      this.ScheduleUnpaidDetais = true;
      this.disabledShoWDate = true;
    }

    if (queryparams.md_id && parseInt(queryparams.md_id)) {
      this.selectedFilter = "Movie";
      this.filterkey = "md_id";
      this.filtervalue = parseInt(queryparams.md_id);
      this.getMoviesList();
    }

    if (queryparams.ss_id && parseInt(queryparams.ss_id)) {
      this.selected_ssid = queryparams.ss_id;
      this.getSchedule();
    }

    this.onFetchUnpaidBookings();
    this.getviewingnumber();
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(null, CinemaObj);
    //   }
    // }
  },
  methods: {
    ExportExcel(type, fn, dl) {
      let cinemaName = this.selectedCinema;
      let fromDate = this.fetchTransactionDetail.show_date
        ? moment(this.fetchTransactionDetail.show_date).format("YYYY-MM-DD")
        : null;
      let toDate = this.fetchTransactionDetail.show_date_to
        ? moment(this.fetchTransactionDetail.show_date_to).format("YYYY-MM-DD")
        : null;
      var today = new Date();
      var date =
        String(today.getDate()).padStart(2, "0") +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        today.getFullYear();
      var time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");

      var dateTime = date + "_AT_" + time;
      let fileName =
        "UnpaidBooking-" +
        cinemaName +
        "_" +
        fromDate +
        "_" +
        fromDate +
        "_on " +
        dateTime +
        (type ? "." + type : ".xlsx");
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Unpaid Booking" });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || fileName);
    },
    sendMail() {
      let loader = this.$loading.show();
      let payload = {
        reservation_id: this.selected_reservation_id,
        customer_id: this.selected_customer_id,
      };
      ExhibitorService.SendMailUnpaidBooking(payload)
        .then((response) => {
          const { data } = response;

          this.$toasted.show(data.message);
          loader.hide();
          this.$bvModal.hide("sendMailConfirmation");
        })
        .catch((err) => {
          console.log("Error:", err);
        });
    },
    sendMailConfirm(reservation_id, customer_id) {
      this.selected_reservation_id = reservation_id;
      this.selected_customer_id = customer_id;
      this.$bvModal.show("sendMailConfirmation");
    },
    moment,
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.onFetchUnpaidBookings();
      } else {
        this.currentPage = event;
        this.onFetchUnpaidBookings();
      }
    },
    onChangeShowDate: _.debounce(function () {
      this.getReservationList = [];
      this.selected_show_time = null;
      this.selected_ssid = "";
      this.currentPage = 1;
      this.getSchedule();
    }, 500),
    onSearchReservation() {
      if (this.searchValue && String(this.searchValue).trim()) {
        this.onFetchUnpaidBookings();
      }
    },
    onSearchFilterValues: function () {
      if (this.searchFilterValues && this.searchFilterValues.length > 0) {
        this.filterValues = this.filterValuesCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            (x.username &&
              x.username
                .toLowerCase()
                .includes(this.searchFilterValues.toLowerCase())) ||
            (x.movie &&
              x.movie
                .toLowerCase()
                .includes(this.searchFilterValues.toLowerCase())) ||
            (x.screen_name &&
              x.screen_name
                .toLowerCase()
                .includes(this.searchFilterValues.toLowerCase()))
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.filterValues = this.filterValuesCopy;
      }
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                });
              }

              if (
                this.fetchTransactionDetail &&
                this.fetchTransactionDetail.cinema_id &&
                x.cine_id === this.fetchTransactionDetail.cinema_id
              ) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectFilter: function (event, params) {
      if (params == "clearFilter") return this.clearFilter();

      this.filterValues = [];
      this.filterValuesCopy = [];
      this.filtervalue = "";
      this.selectedFilterValue = "";
      this.selectedFilter = params;
      if (params == "User") {
        this.filterkey = "t.created_by";
        // this.getUserList(this.fetchTransactionDetail.cinema_id);
      } else if (params == "Screen") {
        this.filterkey = "screen_name";
        this.getScreens(this.fetchTransactionDetail.cinema_id);
      } else if (params == "Movie") {
        this.filterkey = "md_id";
        this.getMoviesList();
      } else if (params == "Show Booking Code") {
        this.filterkey = "sb_booking_code";
        console.log(" this.filterkey :", this.filterkey);
      }
    },
    getMoviesList: function () {
      this.Movies = [];
      MovieService.GetActiveMoviesWithFormat({ movieversions: "Y" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.filterValues = data.Records;
            this.filterValuesCopy = data.Records;

            if (this.filterkey === "md_id" && this.filtervalue) {
              let movie = data.Records.find((x) => x.md_id == this.filtervalue);
              if (movie) {
                this.selectedFilterValue = movie.movie;
              }
            }
          } else {
            // Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getScreens: function (cinema_id) {
      let payload = {
        tableName: "screens",
        screen_is_active: "Y",
        cinema_id: cinema_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.filterValues = data.Records;
            this.filterValuesCopy = data.Records;
          } else {
            // Shoe Error Message:
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(
            "Catch Error on getActiveScreenByCinemaId :",
            error
          );
        });
    },
    onSelectFilterValue: function (params) {
      if (params == "clearFilter") return this.clearFilter();

      if (this.selectedFilter == "User") {
        this.selectedFilterValue = params.username;
        this.filtervalue = params.user_id;
      } else if (this.selectedFilter == "Screen") {
        this.selectedFilterValue = params.screen_name;

        this.filtervalue = params.screen_name;
      } else if (this.selectedFilter == "Movie") {
        this.selectedFilterValue = params.movie;

        this.filtervalue = params.md_id;
      }
      this.searchFilterValues = "";
      this.onSearchFilterValues();
    },
    onFetchUnpaidBookings() {
      if (!this.fetchTransactionDetail.cinema_id) {
        return this.$toasted.show("Please Select Cinema");
      } else if (!this.fetchTransactionDetail.show_date) {
        return this.$toasted.show("Please Select Show Date");
      } else {
        this.getReservationList = [];
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          cinema_id: this.fetchTransactionDetail.cinema_id,
          ss_id: this.selected_ssid || null,
          show_date: this.fetchTransactionDetail.show_date
            ? moment(this.fetchTransactionDetail.show_date).format("YYYY-MM-DD")
            : null,
        };
        ExhibitorService.GetUnpaidBookingTransactions(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records && data.Records.length > 0) {
              this.getReservationList = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue = this.perPage;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
              console.log("this.getReservationList", this.getReservationList);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    openCancelPopUp(reservation_id) {
      this.selected_reservation_id = reservation_id;
      this.$bvModal.show("confirmation");
    },
    cancelUnpaidBooking() {
      let payload = {
        reservation_id: this.selected_reservation_id,
        cinema_id: this.fetchTransactionDetail.cinema_id
      };
      ExhibitorService.CancelUnpaidBooking(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.onFetchUnpaidBookings();
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("error:", err);
        })
        .finally(() => {
          this.$bvModal.hide("confirmation");
        });
    },
    onAsyncSearchUser: _.debounce(function (query) {
      if (query) {
        this.isSearchLoading = true;
        this.searchUserValue = query;
        this.searchUsers = [];
        this.getUserList(this.fetchTransactionDetail.cinema_id);
      }
    }, 1 * 1000),
    clearFilter: function () {
      this.selectedFilterValue = "";
      this.filterValues = [];
      this.filterValuesCopy = [];
      this.selectedFilter = "";
      this.selectedFilterValue = "";
      this.filterkey = "";
      this.filtervalue = "";
    },
    onSelectCinema: function (event, params) {
      this.searchCinema = "";
      this.onSearchCinema(null);
      this.$store.dispatch("selectDropdownCinema", params);
      this.selectedCinema = params.cine_name;
      this.fetchTransactionDetail.cinema_id = params.cine_id;
    },
    getUserList: function (cinema_Id) {
      this.searchUsers = [];
      let body = {
        limit: null,
        currentPage: null,
        orderby: null,
        columnName: null,
        searchValue: this.searchUserValue,
      };
      UserService.ListAllUser({}, body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            this.filterValues = data.data.filter((x) => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
            this.filterValuesCopy = data.data.filter((x) => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
            this.searchUsers = data.data.filter((x) => {
              if (x.cinema_id == cinema_Id) {
                return x;
              }
            });
          } else if (
            data.status == false &&
            data.message == "You are not authorized"
          ) {
            this.$router.push({
              path: "/access-denied",
            });
          } else {
            this.$toasted.show(data.message);
          }
          console.log("this.users :", this.users);
        })
        .catch(this._CatchError)
        .finally(() => {
          this.isSearchLoading = false;
        });
    },
    getSchedule: function () {
      if (
        !this.fetchTransactionDetail.show_date ||
        !this.fetchTransactionDetail.cinema_id
      ) {
        return;
      }
      let payload = {
        ss_show_status: 16,
        cinema_id: this.fetchTransactionDetail.cinema_id,
        start_date: moment(this.fetchTransactionDetail.show_date).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.fetchTransactionDetail.show_date).format(
          "YYYY-MM-DD"
        ),
        groupbyssid: "Y",
      };

      if (this.fetchTransactionDetail.show_date_to)
        payload.end_date = moment(
          this.fetchTransactionDetail.show_date_to
        ).format("YYYY-MM-DD");

      let loader = this.$loading.show();

      scheduleService
        .GetCinemaSchedule(payload)
        .then((result) => {
          this.btenable = false;
          const { data } = result;

          if (data.status) {
            this.schedules = data.Records;

            if (this.selected_ssid) {
              this.schedules.forEach((schedule) => {
                if (schedule.ss_id == this.selected_ssid) {
                  this.selected_show_time = schedule;
                }
              });
            }
          }
        })
        .catch((err) => {
          console.log("err :", err);
        })
        .finally(() => {
          loader.hide();
        });
    },
    onSelectShowtime: function (session) {
      this.selected_show_time = session;
      this.selected_ssid = session.ss_id;
    },
    getShowtimeString: function (schedule) {
      if (!schedule) return "";

      return `${moment(schedule.ss_actual_start_date_time).format(
        "DD-MM-YYYY"
      )} ${schedule.ss_start_show_time} (${schedule.movie})`;
    },
  },
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/UnpaidBookings/unpaidBookings.vue